import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PieChart, pieClasses } from '@mui/x-charts/PieChart';

const BRAND_COLORS = [
  '#425998',
  '#00A598',
  '#8DBAFE',
  '#EF863D',
  '#FFB5BD',
  '#FFCD00',
  '#5DCEBB',
  '#FD8F67',
  '#7980ad',
  '#b4b7ce',
  '#e2eeff',
  '#b4d4ce',
  '#FEE6A0',
  '#fce1b2',
  '#f5ad95',
  '#f6dad3',
  '#A8DADC',
  '#E9C46A',
  '#9B5DE5',
];

export default function BasicPie(props) {
  const { data, loading } = props;
  // set pie chart graphic width to the paper component
  // this way it is responsive and looks good on all screen sizes
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(420);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;
    const observer = new window.ResizeObserver((entries) => {
      setContainerWidth(entries[0].contentRect.width);
    });
    observer.observe(container);
    return () => observer.disconnect();
  }, []);

  const sorted = [...data].sort((a, b) => b.value - a.value);
  const colorByLabel = new Map(sorted.map((item, index) => [item.label, BRAND_COLORS[index]]));
  const coloredData = data.map((item) => ({
    ...item,
    color: colorByLabel.get(item.label) || BRAND_COLORS[sorted.indexOf(item) % BRAND_COLORS.length],
  }));
  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <PieChart
        series={[{
          data: coloredData,
          valueFormatter: (item) => `${item.value.toFixed(1)}%`,
          arcLabel: (params) => `${params.label}`,
          arcLabelMinAngle: 45,
          arcLabelRadius: '65%',
        }]}
        width={containerWidth}
        height={280}
        loading={loading}
        localeText={{ noData: 'No data to display' }}
        slotProps={{
          legend: {
            direction: 'column',
            position: { vertical: 'middle', horizontal: 'right' },
          },
        }}
        sx={{
          [`& .${pieClasses.arcLabel}`]: {
            fontSize: 12,
            fontWeight: 'bold',
          },
        }}
      />
    </div>
  );
}

BasicPie.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.number,
    label: PropTypes.string,
  })).isRequired,
  loading: PropTypes.bool,
};
